var Direction;
( (function(Direction) {
    Direction[Direction["Left"] = 0] = "Left";
    Direction[Direction["Right"] = 1] = "Right";
    Direction[Direction["Up"] = 2] = "Up";
    Direction[Direction["Down"] = 3] = "Down";
})(Direction || (Direction = {})));
var TerminalConnectionState;
( (function(TerminalConnectionState) {
    TerminalConnectionState[TerminalConnectionState["Connecting"] = 0] = "Connecting";
    TerminalConnectionState[TerminalConnectionState["Connected"] = 1] = "Connected";
})(TerminalConnectionState || (TerminalConnectionState = {})));
const isDetachedTerminalInstance = (t) => typeof t.instanceId !== 'number';
class TerminalLinkQuickPickEvent extends MouseEvent {
}
const terminalEditorId = 'terminalEditor';
var XtermTerminalConstants;
( (function(XtermTerminalConstants) {
    XtermTerminalConstants[XtermTerminalConstants["SearchHighlightLimit"] = 1000] = "SearchHighlightLimit";
})(XtermTerminalConstants || (XtermTerminalConstants = {})));
var LinuxDistro;
( (function(LinuxDistro) {
    LinuxDistro[LinuxDistro["Unknown"] = 1] = "Unknown";
    LinuxDistro[LinuxDistro["Fedora"] = 2] = "Fedora";
    LinuxDistro[LinuxDistro["Ubuntu"] = 3] = "Ubuntu";
})(LinuxDistro || (LinuxDistro = {})));
var TerminalDataTransfers;
( (function(TerminalDataTransfers) {
    TerminalDataTransfers["Terminals"] = "Terminals";
})(TerminalDataTransfers || (TerminalDataTransfers = {})));
export { Direction, LinuxDistro, TerminalConnectionState, TerminalDataTransfers, TerminalLinkQuickPickEvent, XtermTerminalConstants, isDetachedTerminalInstance, terminalEditorId };
